import { VFC } from 'react'
import styles from '../../assets/components/templates/Navigation.module.scss'
interface NAVIGATIONPROPS {
    length?: number,
    difficulty: number,
    eventClick: (event: any) => void
}

export const Navigation: VFC<NAVIGATIONPROPS> = ({
    length,
    difficulty = 3,
    eventClick,
}) => {
    const upVisibility = difficulty < 5 ? '' : 'is-hidden'
    const downVisibility = difficulty > 1 ? '' : 'is-hidden'
    const onUpDifficulty = () => eventClick(difficulty + 1)
    const onDownDifficulty = () => eventClick(difficulty - 1)
    
    return (
        <>
            <div className={ styles.navigation_container }>
                <div className="navigation_container__item">
                    <span className="navigation_container__label">Length:</span>
                    <div className="navigation_container__item_number">
                        <div className="navigation_container__item_number___board">{ length }</div>
                    </div>
                </div>
                <div className="navigation_container__item">
                    <span className="navigation_container__label">Difficulty:</span>
                    <div className="navigation_container__item_number">
                        <span className="navigation_container__item_number___board">{ difficulty }</span>
                        <div className={ styles.navigation_container__item_number___button }>
                            <div className={`${styles.difficulty_button} ${styles.difficulty_up} ${upVisibility}`}
                                onClick={onUpDifficulty}>
                                up
                            </div>
                            <div className={`${styles.difficulty_button} ${styles.difficulty_down} ${downVisibility}`}
                                onClick={onDownDifficulty}>
                                down
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}